import PropTypes from "prop-types";
import moment from "moment";
export default function apiDataFormatter(apiData) {
  let advisorData = [];
  advisorData.userId = apiData["advisors"][0].userId;
  advisorData.password = apiData["advisors"][0].password;
  let advisorInfo = [];
  for (let i = 0; i < apiData.advisors.length; i++) {
    let data = apiData.advisors[i];
    let phones = data.phones !== null ? data.phones.map((phone) => {return {addressId: phone.addressId, phonetype: phone.phoneType, phonenumber: phone.phoneNumber, primary: phone.primary === 1 ? true: false }}) : [];
    if(phones.length === 1){ phones[0]["primary"] = true }
    let emails = data.emails !== null ? data.emails.map((email) => {return {addressId: email.addressId, emailId: email.emailId, emailtype: email.emailType, primary: email.primary === 1 ? true: false}}) : [];
    if(emails.length === 1){ emails[0]["primary"] = true }
    let addresses = data.addresses !== null ? data.addresses.map((address) => {return {addressId: address.addressId, addresstype:address.addressType, line1: address.addressLine1, line2: address.addressLine2, line3: address.addressLine3,city: address.city, state: address.state, zipcode: address.zipCode, country: address.country, primary: address.primary === 1 ? true: false, addressUpdated: address.addressUpdated}}) : [];
    if(addresses.length === 1){ addresses[0]["primary"] = true }
    let relatedDonor = data.relatedDonor;
    advisorInfo.push({
      primary: data.primary,
      title: data.title,
      firstname: data.firstName,
      middlename: data.middleName,
      lastname: data.lastName,
      suffix: data.suffix,
      dob: data.dob === "" || data.dob === null ? null : moment(parseInt(data.dob)).format("L"),
      dateOfBirthStr: data.dateOfBirthStr === "" || data.dateOfBirthStr === null ? null : data.dateOfBirthStr,
      gender: data.gender,
      ssn: data.ssn,
      phones: phones,
      emails: emails,
      addresses: addresses,
      deliveryMethod: data.deliveryMethod,
      relatedDonor: relatedDonor,
      role: data.role,
      userId: data.userId
    });
  }
  advisorData["advisors"] = advisorInfo;
  return advisorData;
}

apiDataFormatter.propTypes = {
  advisors: PropTypes.array
}
